import { render, staticRenderFns } from "./AuctionContactDetails.vue?vue&type=template&id=2f921f4f&scoped=true"
import script from "./AuctionContactDetails.vue?vue&type=script&lang=js"
export * from "./AuctionContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f921f4f",
  null
  
)

export default component.exports